module.exports = __webpack_public_path__ + "img/bg-impore-rewords.c3d70b4.jpg";